<!-- <app-cloud-cover-circle></app-cloud-cover-circle> -->

<div class="full-page-container bg-sky">
  <div class="weather-card text-center">
    <h1 class="mb-4">Yamaç Paraşütü için Hava Durumu</h1>
    <p class="lead text-muted mb-4">
    </p>

    <div class="alert alert-danger text-start">
      Bu sayfada yer alan bilgi ve hesaplamalar, uçuş kararı almanız için yeterli değildir. Bilgiler yalnızca eğitim
      amaçlı sunulmuştur ve uçuş kararı alma sorumluluğu tamamen size aittir. Ayrıca yapılan ölçümler yalnızca bir
      tahmindir ve yanılma payı bulunmaktadır; lütfen bunu göz önünde bulundurun.
    </div>

    <!-- Your Angular component -->
    <!-- <app-thermic-index-with-api></app-thermic-index-with-api> -->
    <router-outlet></router-outlet>

  </div>
</div>
<app-modals></app-modals>


